module.exports = __webpack_public_path__ + "static/media/angry.ace616f6.svg";